import { jsx } from "react/jsx-runtime";
import { useState, useMemo } from "react";
import TextField$1 from "@mui/material/TextField/index.js";
import { labelStyles, inputStyles } from "./text-field.styles.js";
const TextField = ({
  value,
  onFocus,
  onBlur,
  InputLabelProps,
  sx,
  autoFocus,
  focused,
  labelOffset,
  labelMaxWidthPercentage,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(focused || autoFocus);
  const shrink = useMemo(() => isFocused || !!value, [isFocused, value]);
  return /* @__PURE__ */ jsx(
    TextField$1,
    {
      variant: "filled",
      InputLabelProps: { shrink, ...InputLabelProps },
      onFocus: (e) => {
        setIsFocused(focused || true);
        onFocus == null ? void 0 : onFocus(e);
      },
      onBlur: (e) => {
        setIsFocused(focused || false);
        onBlur == null ? void 0 : onBlur(e);
      },
      sx: {
        ...(labelOffset || labelMaxWidthPercentage) && labelStyles(labelOffset ?? 0, labelMaxWidthPercentage ?? 0),
        ...inputStyles,
        ...sx
      },
      value,
      autoFocus,
      focused,
      ...rest
    }
  );
};
export {
  TextField
};
